// import router from './router'
// import store from './store'
// import utils from '@/utils'
import FqApi from '@/services/fq-api'

/**
 * Auth Plugin
 *
 * (see https://vuejs.org/v2/guide/plugins.html for more info on Vue.js plugins)
 *
 * Handles login and token authentication using OAuth2.
 */
export default {

  install(Vue, options) {
    Vue.prototype.$auth = Vue.auth = this
  },
  async signIn(credential) {
    const url = '/auth/imageuploader/signin'
    const result = await FqApi.post(url, credential)
    return result.data
  },
  async signOut(jwtToken) {
    const url = '/auth/imageuploader/signout'
    const result = await FqApi.post(url, `=${jwtToken}`)
    return result.data
  },
  async testConnection(companyLoginId, username) {
    const url = `/auth/imageuploader/testConnection/${companyLoginId}/${username}`
    const result = await FqApi.get(url)
    return result.data
  },
  async verifyImageHyperlink(imageHyperlinkId) {
    const url = `/auth/imageuploader/verifyImageHyperlink/${imageHyperlinkId}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getImageHyperlink(imageHyperlinkId) {
   const url = `/auth/imageuploader/getImageHyperlink/${imageHyperlinkId}`
   const result = await FqApi.get(url)
   return result.data
 } 
}
